import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { GrowerProgramService } from '../../../services/seed/growerProgram.service';

@Component({
    selector: 'app-grower-program-import',
    templateUrl: './grower-program-import.component.html',
    styleUrls: ['./grower-program-import.component.scss']
})
export class GrowerProgramImportComponent implements OnInit {
    importDataSource: MatTableDataSource<any> = new MatTableDataSource();
    isSaveButtonDisabled: boolean = true;
    importExclPostData: any;
    subscription = new Array<Subscription>();
    fileData: any[];
    masterData: any;
    landingData: any[] = [];
    filter: any = {};
    errorStatus = Status;
    displayedColumns: string[] = [
        'errorMessage',
        'budgetName',
        'retailerName',
        'estimatedQuantity',
        'estimatedSpend',
        'grower',
        'seller',
        'programName',
        'salesChannel',
        'marketingBrand',
        'productLine',
        //  'approvedPayment',
        //  'customerCreditedAmount',
    ];
    constructor(public growerProgramImportProductDialogRef: MatDialogRef<GrowerProgramImportComponent>,
        private toastrService: ToastrService,
        private loaderService: LoaderService,
        private growerProgramService: GrowerProgramService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.importDataSource = new MatTableDataSource([]);
        this.masterData = data.masterData;
        this.landingData = data.landingData;
        this.filter = data.filterData;
    }

    ngOnInit(): void {
    }

    onFileSelect(event) {
        this.isSaveButtonDisabled = true;
        this.importDataSource = new MatTableDataSource([]);
        let af = ['csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (!af.includes(file.type)) {
                this.toastrService.error('Accepted formats: .xls .xlsx');
            }
            else {
                this.loaderService.setLoaderStatus(true);

                let growerProgramMasterDataVMs: any = {};
                growerProgramMasterDataVMs = this.masterData;
                growerProgramMasterDataVMs.filters = this.filter;

                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    var base64Arr = reader.result.toString().split(',');
                    this.importExclPostData = {
                        mimeType: base64Arr[0].replace("data:", ""),
                        fileName: file.name,
                        base64: base64Arr[1],
                        growerProgramMasterDataVMs: growerProgramMasterDataVMs,
                        //growerProgramLandingVMs: this.landingData
                    };
                    //POST to server
                    this.subscription.push(this.growerProgramService.importSpendDetailsExcelFile(this.importExclPostData).subscribe((result: any) => {
                        if (result.status) {
                            let isErrorExist = result.data.find(x => x.errors.some(x => x.status == 10));
                            if (!isErrorExist) {
                                this.isSaveButtonDisabled = false;
                            }

                            result.data.forEach(x => {
                                x.newErrors = x.errors.filter(x => x.status == Status.Error),
                                    x.newWarnings = x.errors.filter(x => x.status == Status.Warning)
                            });

                            this.importDataSource = new MatTableDataSource(result.data);
                            this.toastrService.success(result.message);
                        }
                        else {
                            this.toastrService.error(result.message);
                        }
                        this.loaderService.setLoaderStatus(false);
                    }, (error) => {
                        this.loaderService.setLoaderStatus(false);
                    }));
                    reader.onerror = function (error) {
                        console.log('Error: ', error);
                    };
                }
            }
        }
    }
    onClose() {
        this.growerProgramImportProductDialogRef.close();
    }
    onSave() {
        this.growerProgramImportProductDialogRef.close(this.importDataSource.data);
    }
}

export enum Status {
    Error = 10,
    Warning = 20
}
